import { Action, handleActions } from 'redux-actions'
import { NotificationDto, NotificationRow, NotificationType, UserNotificationDto } from '../../../services/api.types'
import {
  getUserNotifications,
  getUserNotificationsFail,
  getUserNotificationsSuccess,
  markUserNotificationRead,
  setFeedFilter,
} from './InboxActions'

class State {
  list: UserNotificationDto[] = []
  isLoading: boolean = false
  // Kept in the store so the selection survives the remount when an item route opens.
  feedFilter: NotificationType | null = null
}

export const inbox = handleActions<State, any>(
  {
    [String(getUserNotifications)]: (state: State): State => ({
      ...state,
      isLoading: true,
    }),
    [String(getUserNotificationsSuccess)]: (state: State, action: Action<UserNotificationDto[]>): State => ({
      ...state,
      list: action.payload,
      isLoading: false,
    }),
    [String(getUserNotificationsFail)]: (state: State): State => ({
      ...state,
      isLoading: false,
    }),
    [String(setFeedFilter)]: (state: State, action: Action<NotificationType | null>): State => ({
      ...state,
      feedFilter: action.payload,
    }),
  },
  new State(),
)

export { State as InboxState }
